(function () {
  'use strict';

  if (window.__mamandaReturnNavigationReady) return;
  window.__mamandaReturnNavigationReady = true;

  var originKey = 'mamanda:product-origin:v1';
  var restoreKey = 'mamanda:scroll-restore:v1';
  var maxAge = 30 * 60 * 1000;

  function parseUrl(value) {
    if (!value) return null;
    try {
      var parsed = new URL(value, window.location.href);
      return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function readStorage(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function removeStorage(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  function sameSiteReferrer() {
    var previous = parseUrl(document.referrer);
    if (!previous || previous.origin !== window.location.origin) return null;
    if (previous.pathname === window.location.pathname) return null;
    return previous;
  }

  function trackedOrigin() {
    var saved = readStorage(originKey);
    if (!saved || typeof saved.source !== 'string') return null;
    if (typeof saved.timestamp !== 'number' || Date.now() - saved.timestamp > maxAge || Date.now() < saved.timestamp) return null;
    if (saved.destinationPath !== window.location.pathname) return null;

    var source = parseUrl(saved.source);
    if (!source || source.origin !== window.location.origin || source.pathname === window.location.pathname) return null;
    if (!Number.isFinite(saved.x) || !Number.isFinite(saved.y)) return null;
    return { source: source, x: saved.x, y: saved.y };
  }

  function findReturnTarget() {
    var referrer = sameSiteReferrer();
    var saved = trackedOrigin();

    if (saved && (!referrer || referrer.pathname === saved.source.pathname)) {
      return { url: saved.source, referrer: referrer, position: saved };
    }
    if (referrer) {
      return { url: referrer, referrer: referrer, position: null };
    }
    return null;
  }

  function updateReturnLinks() {
    var target = findReturnTarget();
    document.querySelectorAll('a.mp-browse').forEach(function (link) {
      if (!link.dataset.mamandaFallback) link.dataset.mamandaFallback = link.href;
      link.href = target ? target.url.href : link.dataset.mamandaFallback;
    });
  }

  function prepareScrollRestore(position) {
    if (!position) return;
    writeStorage(restoreKey, {
      url: position.source.href,
      x: Math.max(0, position.x),
      y: Math.max(0, position.y),
      timestamp: Date.now()
    });
  }

  function restoreScrollIfNeeded() {
    var saved = readStorage(restoreKey);
    if (!saved) return;
    if (typeof saved.timestamp !== 'number' || Date.now() - saved.timestamp > 120000 || Date.now() < saved.timestamp) {
      removeStorage(restoreKey);
      return;
    }
    if (saved.url !== window.location.href) return;

    removeStorage(restoreKey);
    var x = Math.max(0, Number(saved.x) || 0);
    var y = Math.max(0, Number(saved.y) || 0);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        window.scrollTo(x, y);
      });
    });
    window.setTimeout(function () {
      if (Math.abs(window.scrollY - y) > 4) window.scrollTo(x, y);
    }, 180);
  }

  function clearOldOriginOnReturn() {
    var saved = readStorage(originKey);
    if (saved && saved.source === window.location.href) removeStorage(originKey);
  }

  document.addEventListener('click', function (event) {
    var element = event.target;
    if (!element || typeof element.closest !== 'function') return;
    var link = element.closest('a[href]');
    if (!link || event.defaultPrevented) return;

    if (link.classList.contains('mp-browse')) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = findReturnTarget();
      if (!target) return;

      event.preventDefault();
      prepareScrollRestore(target.position);
      removeStorage(originKey);

      if (target.referrer && target.referrer.pathname === target.url.pathname && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.assign(target.url.href);
      }
      return;
    }

    var destination = parseUrl(link.href);
    if (!destination || destination.origin !== window.location.origin) return;
    if (!/(?:^|\/)products\/[^/]+/.test(destination.pathname)) return;
    if (destination.pathname === window.location.pathname) return;

    writeStorage(originKey, {
      source: window.location.href,
      destinationPath: destination.pathname,
      x: Math.max(0, Math.round(window.scrollX)),
      y: Math.max(0, Math.round(window.scrollY)),
      timestamp: Date.now()
    });
  }, true);

  function onPageReady() {
    updateReturnLinks();
    restoreScrollIfNeeded();
    clearOldOriginOnReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onPageReady, { once: true });
  } else {
    onPageReady();
  }
  window.addEventListener('pageshow', onPageReady);
  document.addEventListener('shopify:section:load', updateReturnLinks);
})();
